<template>
  <PackageCardGrid :packages="packages">
    <template #footer>
      <ServicesCoverageFooter />
    </template>
  </PackageCardGrid>
</template>

<script>
import PackageCardGrid from './PackageCardGrid.vue';
import ServicesCoverageFooter from './ServicesCoverageFooter.vue';

export default {
  name: 'PackagesSectionContainer',
  components: {
    PackageCardGrid,
    ServicesCoverageFooter,
  },
  props: {
    packages: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>
